"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _useFetch = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useFetch"));
var _UiContext = _interopRequireDefault(require("@micado-digital/react-ui/context/UiContext"));
var _ProductDetailContext = _interopRequireDefault(require("./context/ProductDetailContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ProductDetail = function ProductDetail(_ref) {
  var children = _ref.children,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    _ref$fetchData = _ref.fetchData,
    fetchData = _ref$fetchData === void 0 ? false : _ref$fetchData,
    _ref$lang = _ref.lang,
    lang = _ref$lang === void 0 ? "de" : _ref$lang,
    pagename = _ref.pagename;
  var REACT_APP_PATH = process.env.REACT_APP_PATH;
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    attributes = _useState2[0],
    setAttributes = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    combinationValues = _useState4[0],
    setCombinationValues = _useState4[1];
  var _useState5 = (0, _react.useState)({
      _loading: true
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    productDetailData = _useState6[0],
    setProductDetailData = _useState6[1];
  var _useContext = (0, _react.useContext)(_UiContext.default),
    _useContext2 = _slicedToArray(_useContext, 1),
    ui = _useContext2[0];
  var _ui$_location = ui._location,
    _ui$_location2 = _ui$_location === void 0 ? {} : _ui$_location,
    _ui$_location2$pathna = _ui$_location2.pathname,
    pathname = _ui$_location2$pathna === void 0 ? "" : _ui$_location2$pathna;
  var fetchURL = "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.ProductApi/Details.api?lang=").concat(lang, "&pagename=").concat(pagename);
  var detailData = (0, _useFetch.default)(fetchURL, [lang, pagename, pathname], pagename === pathname && fetchData);
  (0, _react.useEffect)(function () {
    setProductDetailData({});
  }, [pagename]);
  (0, _react.useEffect)(function () {
    if (!fetchData) return;
    setProductDetailData(detailData);
  }, [detailData, fetchData]);
  (0, _react.useEffect)(function () {
    if (fetchData || (0, _isEmpty.default)(data)) return;
    setProductDetailData(typeof data === "string" ? JSON.parse(data) : data);
  }, [data, fetchData]);
  return /*#__PURE__*/_react.default.createElement(_ProductDetailContext.default.Provider, {
    value: {
      attributes: attributes,
      combinationValues: combinationValues,
      productDetailData: productDetailData,
      setAttributes: setAttributes,
      setCombinationValues: setCombinationValues,
      setProductDetailData: setProductDetailData
    }
  }, children);
};
ProductDetail.propTypes = {
  data: _propTypes.default.object,
  fetchData: _propTypes.default.bool,
  lang: _propTypes.default.string,
  pagename: _propTypes.default.string.isRequired
};
var _default = ProductDetail;
exports.default = _default;